import { clusterTerminationData } from "../constants";
import ModuleBlock from "./ModuleBlock";

export default class EdgeModuleBlock extends ModuleBlock {

  width() {
    if (!this.hasWidth()) {
      return '-';
    }

    let width = this.modules.map(m => m.width)
      .reduce((a, b) => parseFloat((a + b).toFixed(2)), 0.0);

    width += clusterTerminationData.width;

    return width.toString();
  }

}
